module.exports = __webpack_public_path__ + "static/media/main-small-section-left-1.74a205e7.png";